module.exports = __webpack_public_path__ + "assets/validated.58852b53.svg";